export default class DefaultSignupStrategy {
  constructor() {
    this.isDefault = true;
    this.hasLogo = false;
    this.logo = '';
    this.logoStyle = '';
    this.logoAltText = '';
    this.pageClass = 'col-md-6 col-lg-4 card card-signup';
    this.header = 'Sign Up';
    this.headline = 'Start your free trial now. No credit card required.';
    this.showCoupon = true;
    this.termsLink = 'https://www.pwrlab.com/terms';
    this.privacyLink = 'https://www.pwrlab.com/privacy';
    this.pageStyle = '';
    this.rootStyle = '';
    this.h3Style = '';
  }
}
